import React from 'react';

import Avatar from '@material-ui/core/Avatar';
import Box from '@material-ui/core/Box';
import CardMedia from '@material-ui/core/CardMedia';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import Paper from '../Paper';
import Spinner from '../Spinner';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  cardContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0 16px',
    marginBottom: theme.spacing(),
    width: 350,
  },
  title: {
    fontWeight: theme.typography.fontWeightBold,
    textAlign: 'center',
  },
  avatar: {
    height: 80,
    width: 80,
    boxShadow: '0 2px 10px rgba(199, 199, 199, 1)',
    marginTop: -40,
    marginBottom: theme.spacing(),
  },
  stampCardRoot: {
    [theme.breakpoints.up('sm')]: {
      padding: `${theme.spacing()}px ${theme.spacing(2.5)}px 0`,
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(),
    },
    marginBottom: theme.spacing(),
  },
  tile: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: theme.spacing(),
  },
  noCardText: {
    fontSize: 16,
    fontWeight: 800,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2),
    textAlign: 'center',
    padding: theme.spacing(5),
  },
  cardMedia: {
    height: 220,
    width: 350,
    borderTopRightRadius: 10,
    borderTopLeftRadius: 10,
    backgroundSize: 'cover',
  },
  merchantProfile: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
  boxContainer: {
    marginTop: 40,
  },
}));

type Props = {
  merchantName: string;
  merchantCoverImage?: string;
  merchantLogo?: string;
  loading?: boolean;
};

export default function EmptyStampCard({
  merchantName,
  merchantCoverImage,
  merchantLogo,
  loading,
}: Props) {
  const classes = useStyles();

  return (
    <Grid item xs={12} className={classes.root}>
      <Paper className={classes.cardContainer}>
        <CardMedia className={classes.cardMedia} image={merchantCoverImage} />
        <div className={classes.merchantProfile}>
          <Avatar
            alt={merchantName}
            src={merchantLogo}
            className={classes.avatar}
          />
          {!loading && (
            <Typography variant="h5" className={classes.title} gutterBottom>
              {merchantName}
            </Typography>
          )}
        </div>
        <div className={classes.stampCardRoot}>
          {/* {!loading && (
            <Typography className={classes.noCardText} gutterBottom>
              {' '}
            </Typography>
          )} */}
          {loading && (
            <Box
              display="flex"
              justifyContent="center"
              className={classes.boxContainer}
            >
              <Spinner />
            </Box>
          )}
        </div>
      </Paper>
    </Grid>
  );
}
